import React, { useEffect, useState } from "react";
import WebGlTutorial from "components/WebGlTutorial/WebGlTutorial";
import { getWebGLCapabilities } from "../../../helpers/utilityHelpers";
import { useTheme, useMediaQuery } from "@mui/material";

const GameFrame = ({ curUrl, lock, openGame }) => {
  const [frame, setFrame] = useState(null);
  const webGlCapabilities = getWebGLCapabilities();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const engineStartsWith = (value, prefixes) => {
    return prefixes.some((item) => value.toLowerCase().startsWith(item));
  };

  const handleBypass = () => {
    setFrame(
      <iframe
        id="openGameFrame"
        referrerPolicy="no-referrer-when-downgrade"
        title="openGameFrame"
        onLoad={() => lock("landscape")}
        allow="autoplay *; fullscreen *; camera *; microphone *;"
        src={curUrl}
        width="100%"
        height="100%"
        style={{ pointerEvents: "all" }}
      />
    );
  };

  useEffect(() => {
    if (curUrl) {
      // GODOT 4 → precisa WebGL2
      if (engineStartsWith(openGame.engine, ["godot_4"])) {
        if (!webGlCapabilities.webgl2 && !isMobile) {
          setFrame(<WebGlTutorial onBypass={handleBypass}/>);
          return;
        }
      }
      // GODOT 3 / CONSTRUCT
      if (engineStartsWith(openGame.engine, ["godot_3", "construct"])) {
        if (!webGlCapabilities.suportAnyWebGL && !isMobile) {
          setFrame(<WebGlTutorial />);
          return;
        }
      }
      setFrame(
        <iframe
          id="openGameFrame"
          referrerPolicy="no-referrer-when-downgrade"
          title="openGameFrame"
          onLoad={() => lock("landscape")}
          allow="autoplay *; fullscreen *;  camera *; microphone *;"
          src={curUrl}
          width="100%"
          height="100%"
          style={{ pointerEvents: "all" }}
        ></iframe>,
      );
    }

    //   if (webGlCapabilities.suportAnyWebGL && true == false)
    //     setFrame(
    //       <iframe
    //         id="openGameFrame"
    //         referrerPolicy="no-referrer-when-downgrade"
    //         title="openGameFrame"
    //         onLoad={() => lock("landscape")}
    //         allow="autoplay *; fullscreen *;  camera *; microphone *;"
    //         src={curUrl}
    //         width="100%"
    //         height="100%"
    //         style={{ pointerEvents: "all" }}
    //       ></iframe>,
    //     );
    // } else {
    //   setFrame(<WebGlTutorial />);
    // }
  }, [curUrl]);

  return frame;
};

export default GameFrame;
